import { PROTECT_PERIOD_OPTIONS } from '~services/constant/business';
import HelperOptions from '~component/helper/helper-options';

// 商机保护期
export default {
  functional: true,
  render(createElement, context) {
    const { data } = context;

    return (
      <HelperOptions
        { ...data }
        options={ PROTECT_PERIOD_OPTIONS }
      />
    );
  },
};
